/** What a new API key is called when nobody names it: after who it acts as, and the client it's for. */

/** Folded for comparing names: case and spaces around aside. */
const fold = (s: string) => s.trim().toLocaleLowerCase();

/**
 * The name a key for `agent` gets by default: its name ("Muse"), or with the client it's set up in ("Muse · Cursor"),
 * followed by " 2", " 3"… when a key of the organization (`taken`) is already called that.
 */
export function defaultKeyName(agent: string, client: string | null | undefined, taken: readonly string[]): string {
  const who = agent.trim();
  const base = client && who ? `${who} · ${client}` : who || (client ?? "");
  const used = new Set(taken.map(fold));
  if (!used.has(fold(base))) {
    return base;
  }
  let n = 2;
  while (used.has(fold(`${base} ${n}`))) {
    n += 1;
  }
  return `${base} ${n}`;
}
